import { theme } from '@theme';
import styled from 'styled-components';

export const CarModel = styled.p<{ isRead?: boolean }>`
  color: ${theme.palette.dusty};
  font-size: 11px;

  ${(props) =>
    props.isRead
      ? `
      color: ${theme.palette.silver};
    `
      : ``}
`;

export const Copy = styled.p<{ isRead?: boolean }>`
  padding: 4px 10px 0 0;

  ${(props) =>
    props.isRead
      ? `
      color: ${theme.palette.darkGreyThree};
    `
      : ``}
`;

export const BPS = styled.span.attrs({
  className: 'bps',
})<{ isRead?: boolean }>`
  display: block;
  position: static;
  width: 55px;

  background: ${theme.palette.lightPurpleTwo};
  border-radius: 4px;
  text-align: center;
  top: 10px;
  right: 38px;
  padding: 5px;
  min-width: 44px;

  em {
    font-size: ${theme.typography.fontSize14}px;
    color: ${theme.palette.darkPurpleTwo};
    line-height: 16px;
    display: block;
    font-style: normal;
  }
  b {
    font-size: ${theme.typography.fontSize20}px;
    color: ${theme.palette.darkPurpleThree};
    line-height: 1;
    span {
      color: ${theme.palette.dusty};
      vertical-align: top;
      font-size: 80%;
    }
  }

  ${(props) =>
    props.isRead
      ? `
      background-color: ${theme.palette.lightGrayFive};
      width: 55px;
      margin: 0 5px;
      b {
        color: ${theme.palette.dusty};
      }
      em {
        color:${theme.palette.dusty};
      }

      &:hover {
        background-color: ${theme.palette.lightGrayFive};
        b {
          color: ${theme.palette.dusty};
        }
        em {
          color: ${theme.palette.dusty};
        }
      }
  `
      : ``}
`;

export const ListItem = styled.li<{ isRead?: boolean }>`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${theme.palette.basicGray};
  font-size: ${theme.typography.fontSize14}px;
  font-weight: ${theme.typography.fontWeights.normal};
  list-style: none;
  min-height: 80px;
  border-bottom: 1px solid ${theme.palette.lightGreySeven};
  user-select: none;

  &.service {
    padding-right: 130px;
  }
  p {
    margin: 0 0 5px;
    line-height: 1.2;
  }
  &.empty {
    padding: 10px;
    p {
      line-height: 44px;
    }
  }
  .am-icon {
    font-size: 255%;
    margin-right: 10px;
  }
  .am-icon:last-child {
    margin-right: 10px;
  }
  .am-icon-service {
    font-size: 230%;
  }
  .am-icon-eye {
    font-size: 230%;
  }
  .am-icon-campaign {
    font-size: 230%;
    margin-left: 0px;
  }
  .am-icon-logo-mdl {
    right: 89px;
    left: auto;
    top: 2px;
    color: ${theme.palette.lightGreyEight};
    font-size: 285%;
  }
  .am-icon-rfid {
    color: ${theme.palette.lightGreyEight};
    font-size: 245%;
  }
  .am-icon-conquest {
    font-size: 210%;
  }
  .am-icon-color-grey {
    color: ${theme.palette.lightGreyEight};
  }

  ${(props) =>
    props.isRead
      ? `
      background-color: ${theme.palette.lightPurpleEight};
      > .am-icon {
        color: ${theme.palette.darkGreyThree};
      }
      .am-icon-logo-mdl {
        color: ${theme.palette.silver};
      }
      .am-icon-rfid {
        color: ${theme.palette.silver};
      }

      &:hover {
        background-color: ${theme.palette.basicGrayTwo};
      }
    `
      : ``}

  position: relative;

  &:hover:not(.empty) {
    cursor: pointer;
    background: ${theme.palette.lightPurpleTwo};
    .bps {
      background: ${theme.palette.white};
    }
  }
`;
